import { render } from "./NativeComponentEditorCmp.vue?vue&type=template&id=0d166132"
import script from "./NativeComponentEditorCmp.vue?vue&type=script&lang=js"
export * from "./NativeComponentEditorCmp.vue?vue&type=script&lang=js"

import "./NativeComponentEditorCmp.vue?vue&type=style&index=0&id=0d166132&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__